import {
  SET_SHOW_LOADING_ADVANCEMENTS,
  SET_ADVANCEMENT_SIMULATION,
  SET_ADVANCEMENT_STATUS,
  SET_ADVANCEMENT_DETAILS,
  RESET_ADVANCEMENT_DETAILS,
  SET_ADVANCEMENT_ERROR,
} from './actionTypes';

export const initialState = {
  showAdvancementsLoading: false,
  advancementSimulation: null,
  advancementDetails: null,
  advancementError: false,
  advancementStatus: {
    status: null,
    requestId: null,
    requestCounter: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_LOADING_ADVANCEMENTS: {
      return {
        ...state,
        showAdvancementsLoading: action.payload,
      };
    }
    case SET_ADVANCEMENT_SIMULATION: {
      return {
        ...state,
        advancementSimulation: action.payload,
      };
    }
    case SET_ADVANCEMENT_STATUS: {
      return {
        ...state,
        advancementStatus: action.payload,
      };
    }
    case SET_ADVANCEMENT_DETAILS:
      return {
        ...state,
        advancementDetails: action.payload,
      };
    case RESET_ADVANCEMENT_DETAILS:
      return {
        ...state,
        advancementDetails: null,
      };
    case SET_ADVANCEMENT_ERROR:
      return {
        ...state,
        advancementError: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
